<template>
    <div class="jobtype">
        <div class="group" v-if="use_radio">
            <input
            class="radio"
            type="radio"
            id="AAA"
            name="job"
            value="AAA"
            @click="radioSelect('5• AAA')"
            checked/>
            <label for="AAA">AAA</label>
        </div>
        <div class="group" v-if="use_radio">
            <input
            class="radio"
            type="radio"
            id="AAD"
            name="job"
            value="AAD"
            @click="radioSelect('6• AAD')"/>
            <label for="AAD">AAD</label>
        </div>
        <div class="group" v-if="use_radio">
            <input
            class="radio"
            type="radio"
            id="AAA_AAD"
            name="job"
            value="AAA_AAD"
            @click="radioSelect('5• AAA,6• AAD')"/>
            <label for="AAA_AAD">AAA + AAD</label>
        </div>
        <div class="group" v-if="use_radio">
            <input
            class="radio"
            type="radio"
            id="COM_AAD"
            name="job"
            value="COM_AAD"
            @click="radioSelect('9• COM,6• AAD')"/>
            <label for="COM_AAD">COM + AAD</label>
        </div>
        <div class="group" v-if="use_radio">
            <input
            class="radio"
            type="radio"
            id="OTHER"
            name="job"
            value="OTHER"
            @click="radioSelect('OTHER')"/>
            <label for="OTHER" style="margin-right:10px">OTHER</label>

            <autocomplete
            v-if="other==true"
            :selectable=true
            :index=0
            :type=0
            :fixed=fixed
            v-on:input="setData"
            style="width:200px; float:right"/>
            <autocomplete
            v-else
            :selectable=false
            :index=0
            :type=0
            :fixed=fixed
            v-on:input="setData"
            style="width:200px; float:right"/>
        </div>
        <div v-else>
            <autocomplete
            :index=0
            :value=search
            :type=0
            :fixed=fixed
            v-on:input="setData"
            style="width:100%"
            />
        </div>
    </div>
</template>

<script>
import api from '@/api'
import router from '@/router/index'
export default {
    name: 'jobtype',

    props: {
        index: Number,
        search: String,
        use_radio: true,
        fixed: {
            type: Boolean,
            required: false,
            default: false
        },
    },

    data() {
        return {
            select: '',
            other:false
        };
    },
    async created(){
        if(!this.use_radio){
            this.radioSelect('OTHER');
        }else{
            this.radioSelect('5• AAA');
        }
    },
    methods: {
        radioSelect(value){
            if(value!='OTHER'){
                this.other=false;
                this.select=value;
            }else {
                this.other=true;
                this.select=this.search;
            }
            this.sendData();
        },
        setData(value){
            if(this.search!=value) {
                this.search = value;
                if(this.use_radio){
                    document.getElementById('OTHER').checked=true;
                }
                this.radioSelect('OTHER');
            }
        },
        sendData(){
            this.$emit('input',  this.index, this.select);
        }
    }
};
</script>

<style>
.jobtype{
    position: relative;
    display:inline-block;
    width:100%;
}
.radio {
    width:25px;
}
.group{
    display:inline-block;
    margin-right:50px;
}
</style>



// WEBPACK FOOTER //
// src/layouts/jobtype.vue